import React from 'react';
import MCQuestionEditor from './MCQuestion';
import ShortQuestionEditor from './ShortQuestion';
import LongQuestionEditor from './LongQuestion';
import ReactTooltip from 'react-tooltip';
import createConfirm from '../Modal/createConfirm';

var QuestionContainer = React.createClass({
  questionTypes: [{
    title: "Multiple Choice",
    value: 11
  }, {
    title: "Short Answer",
    value: 21
  }, {
    title: "Long Answer",
    value: 22
  }],
  questionTypesNew: [{
    title: "Multiple Choice",
    value: 11
  }, {
    title: "Short Answer (New)",
    value: 21
  }, {
    title: "Long Answer (New)",
    value: 22
  }],
  diffLevels: [{
    value: 0.25,
    title: "A - 1",
    score: 1,
    allowTypes: [11, 21, 22]
  },{
    value: 0.5,
    title: "B - 2",
    score: 2,
    allowTypes: [11, 21, 22]
  },{
    value: 0.75,
    title: "C - 3",
    score: 3,
    allowTypes: [11, 21, 22]
  },{
    value: 1,
    title: "D - 4",
    score: 4,
    allowTypes: [11, 21, 22]
  },
  {
    value: "1",
    title: "E - 5",
    score: 5,
    allowTypes: [22]
  }],
  newMCQuestion: function() {
    return [{
      text: "",
      image: "",
      answerValue: 1
    }, {
      text: "",
      image: "",
      answerValue: 0
    }, {
      text: "",
      image: "",
      answerValue: 0
    }, {
      text: "",
      image: "",
      answerValue: 0
    }];
  },
  newStructuredQuestion: function() {
    return [{
      preText: "",
      text: "",
      postText: "",
      description: "",
      answerValue: 0
    }]
  },
  newStructuredLongQuestion: function() {
    return [{
      preText: "",
      text: "",
      postText: "",
      description: "",
      answerValue: 0,
      type: "MANUAL_MARKING"
    }]
  },
  onQuestionTypeChange: function(e) {
    var newTypeValue = parseInt(e.target.value);
    var question = this.state.question;
    question.kquestion.type = newTypeValue;
    console.log(question)
    switch (newTypeValue) {
      case 11:
        question.kquestion.selectionChoices = this.newMCQuestion();
        question.kquestion.textInputAnswers = [];
        question.kquestion.solution.splice(0, question.kquestion.solution.length);
        question.kquestion.description = '';
        question.kquestion.metadata.description = '';
        delete question.kquestion.image;
        break;
      case 21:
        question.kquestion.selectionChoices = [];
        question.kquestion.textInputAnswers = this.newStructuredQuestion();
        question.kquestion.solution.splice(0, question.kquestion.solution.length);
        delete question.kquestion.image;
        break;
      case 22:
        question.kquestion.selectionChoices = [];
        question.kquestion.textInputAnswers = this.newStructuredLongQuestion();
        question.kquestion.solution.splice(0, question.kquestion.solution.length);
        question.kquestion.solution.push({
          subItems: []
        });
        delete question.kquestion.image;
      break;
      default: break;
    }
    this.setState({
      type: newTypeValue,
      question: question
    })
  },
  onDiffLevelChange: function(e) {
    var score = parseFloat(e.target.value);
    var newDiffLevel = 1;
    if(score<4){
      newDiffLevel = score/4;
    }
    var question = this.state.question;

    question.kquestion.diffLevel = newDiffLevel;
    question.kquestion.score = score;
    this.setState({
      diffLevel: newDiffLevel,
      question: question,
      score: score
    })
  },
  removeQuestion: function() {
    var _this = this;
    this.confirmable = createConfirm({
      title: "Confirm",
      content: "Are you sure you want to remove this question?"
    }, function() {
      _this.setState({openConfirmModal: false});
      _this.props.onQuestionRemoved();
    }, function(){
      _this.setState({openConfirmModal: false});
    });
    this.setState({openConfirmModal: true});
  },
  getInitialState: function() {
    return {
      type: this.questionTypes[0].value,
      diffLevel: this.diffLevels[0].value,
      question: this.props.question,
      questionTypes: this.props.question.kquestion.subtype && this.props.question.kquestion.subtype.editor === "old" ?  this.questionTypes : this.questionTypesNew
    };
  },
  componentWillMount: function() {

  },
  componentWillReceiveProps: function(nextProps) {
    console.log('question container receive new props');
    this.setState({
      question: nextProps.question,
      diffLevel: nextProps.question.kquestion.diffLevel,
      type: nextProps.question.kquestion.type
    })

    // if(nextProps.question.kquestion.subtype && nextProps.question.kquestion.subtype.editor === "old"){
    //   this.setState({
    //     questionTypes: [{
    //       title: "Multiple Choice",
    //       value: 11
    //     }, {
    //       title: "Short Answer",
    //       value: 21
    //     }, {
    //       title: "Long Answer",
    //       value: 22
    //     }]
    //   })
    // }else {
    //   this.setState({
    //     questionTypes: [{
    //       title: "Multiple Choice",
    //       value: 11
    //     }, {
    //       title: "Short Answer (New)",
    //       value: 21
    //     }, {
    //       title: "Long Answer (New)",
    //       value: 22
    //     }]
    //   })
    // }
  },
  render: function() {
    var _this = this;
    console.log('question in question container',this.state.question)
    return (
      <div className="question-container">
        {this.state.openConfirmModal && this.confirmable}
        <h3>Question {this.props.questionIndex+1}</h3>
        <i className="fa fa-trash delete-icon" onClick={_this.removeQuestion} data-tip data-for={"tt-question-" + this.props.questionIndex}></i>
        <ReactTooltip id={"tt-question-" + this.props.questionIndex} effect="solid">Remove question</ReactTooltip>
        <div className="question-type">
          <div className="form-group">
            <label>Question Type</label>
            <select className="form-control" value={this.state.question.kquestion.type} onChange={this.onQuestionTypeChange}>
              {
                this.state.questionTypes.map(function(type, index) {
                  return <option key={index} value={type.value}>{type.title}</option>
                })
              }
            </select>
          </div>
          <div className="form-group">
            <label>Difficulty Level</label>
            <select className="form-control" value={this.state.question.kquestion.score} onChange={this.onDiffLevelChange}>
              {
                this.diffLevels.map((diffLevel, index) => {
                  if (diffLevel.allowTypes.indexOf(this.state.question.kquestion.type) >= 0) return <option key={index} value={diffLevel.score}>{diffLevel.title}</option>
                  return
                })
              }
            </select>
          </div>
        </div>
        <div className="question-content">
          {
            (this.state.question.kquestion.type === 11 && <MCQuestionEditor kquestion={this.state.question.kquestion} questionIndex={this.props.questionIndex} />)
            ||
            (this.state.question.kquestion.type === 21 && <ShortQuestionEditor kquestion={this.state.question.kquestion} questionIndex={this.props.questionIndex} />)
            ||
            (this.state.question.kquestion.type === 22 && <LongQuestionEditor kquestion={this.state.question.kquestion} questionIndex={this.props.questionIndex} subject={this.props.subject} />)
          }
        </div>
      </div>
    )
  },
  componentDidMount: function() {

  }
})

export default QuestionContainer;



/** WEBPACK FOOTER **
 ** ./src/components/CollectionEditor/QuestionContainer.js
 **/